import FormHelpers from '../util/form';
import {
    newModalFromString
} from '../components/modal';
import RegistrationHelper from './registrationHelper';

const toggleLoyaltyPopover = function (state) {
    $('.policy-promotion-loyalty').find('.slider').toggleClass('loyalty-highlight', state);

    if (state) {
        $('.popover-loyalty-member-int').fadeIn('fast', function () {
            $(this).removeClass('hidden');
        });
    } else {
        $('.popover-loyalty-member-int').fadeOut('fast', function () {
            $(this).addClass('hidden');
        });
    }
};

/**
 * Show alert if loyalty flag is off.
 */
const checkLoyaltyFlag = function () {
    var button = $('.button-register-final');

    if ((RegistrationHelper.isRegistrationModalFlow() && $('.registrationModal-box').attr('data-registration-modal-stage') === 'phone') || (RegistrationHelper.isRegistrationLoyaltyModalFlow() && $('.registrationModal-box').attr('data-registration-modal-stage') === 'registration')) {
        return true;
    }

    if (!button.length || $('.policy-promotion-loyalty').hasClass('hidden') || $('.policy-promotion-loyalty').length === 0) {
        return true;
    }

    var loyaltyFlagState = button.data('loyalty-check');
    if (!loyaltyFlagState) {
        button.data('loyalty-check', true);
    }
    toggleLoyaltyPopover(!loyaltyFlagState);

    return loyaltyFlagState;
};

const toggleRememberPopover = function (fromLayer, state) {
    const location = fromLayer ? '.layer-login-modal ' : '.login-form-container ';
    if (state) {
        $(location + '.popover-remember-me').fadeIn('fast', function () {
            $(this).removeClass('hidden');
        });
    } else {
        $(location + '.popover-remember-me').fadeOut('fast', function () {
            $(this).addClass('hidden');
        });
    }
};

/**
 * Show alert if Remember flag is off.
 */
const checkRememberFlag = function (fromLayer) {
    var button = $('#rememberMe');
    if (fromLayer) {
        button = $('.layer-login-modal #rememberMeTwo');
    }

    if (!button.length || button.is(':checked')) {
        return true;
    }

    var rememberMeFlagState = button.data('rememberMe-check');
    if (!rememberMeFlagState) {
        button.data('rememberMe-check', true);
    }

    toggleRememberPopover(fromLayer, !rememberMeFlagState);

    return rememberMeFlagState;
};

const initNewsletterAnalyticsBrands = function () {
    if (!window.newsletterPreferenceBrands) {
        window.newsletterPreferenceBrands = [];
    }
};

export function formatDate (date, formatPattern) {
    if (formatPattern === 'dd-mm-yyyy') {
        return ('0' + date.getDate()).slice(-2) + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' +
            date.getFullYear();
    } else if (formatPattern === 'mm-dd-yyyy') {
        return ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2) + '-' +
            date.getFullYear();
    } else if (formatPattern === 'yyyy年mm月dd日') {
        var dateParsed = (date.getFullYear() + '年' + ('0' + (date.getMonth() + 1)).slice(-2) + '月' + ('0' + date.getDate()).slice(-2) + '日');
        return dateParsed;
    }
}

class Customer {
    constructor () {
        this.accountLogin = 'form.login';
        this.accountRegister = 'form.registration';
        this.accountLoyalty = 'form.loyalty';
        this.resetPassword = '.reset-password-form';
        this.checkoutLogin = 'form.login';
        this.checkoutRegister = 'form.checkout-registration';
        this.editProfile = 'form.edit-profile-form';
        this.editPassword = 'form.change-password-form';

        this.initSuccessBlockSaveFadeOut();
    }

    initSuccessBlockSaveFadeOut () {
        var $element = $('.success-block-save[data-just-updated="true"]:not([data-fading])');
        if ($element.length) {
            $element
                .attr('data-fading', 'true')
                .fadeIn()
                .removeClass('hidden')
                .delay(5000)
                .fadeOut(function () {
                    $(this).addClass('hidden').removeAttr('data-fading');
            });
        }
    }

    toggleVisiblePassword () {
        if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
            $('body').on('touchend', '.toggle-password', function (e) {
                const password = $(this).closest('.form-fields-item__label').find('.pwd-input');
                const type = password.attr('type') === 'password' ? 'text' : 'password';
                password.attr('type', type);
                $(this).toggleClass('toggle-password--visible');
                e.stopImmediatePropagation();
            });
        } else {
            $('body').on('click', '.toggle-password', function (e) {
                const password = $(this).closest('.form-fields-item__label').find('.pwd-input');
                const type = password.attr('type') === 'password' ? 'text' : 'password';
                password.attr('type', type);
                $(this).toggleClass('toggle-password--visible');
                e.stopImmediatePropagation();
            });
        }
    }

    turnLoginImg () {
        if ($('.js-link-access').hasClass('current')) {
            $('.js-img-login-turn').show();
        } else {
            $('.js-img-login-turn').hide();
        }

        if ($('.js-link-register').hasClass('current')) {
            $('.js-img-registration-turn').show();
        } else {
            $('.js-img-registration-turn').hide();
        }
    }

    fireGenericAnalyticsErrorEvent (type, flow, step, errorMsg) {
        $('body').trigger('customer:account_error', {
            'type': type,
            'flow': flow || 'loyalty_registration',
            'step': step,
            'errorMsg': errorMsg
            
        });
    }

    fireSpecificAnalyticsErrorEvent (mainType, flow, subType, error, rememberMe, sessionExpired) {
        $('body').trigger('customer:' + mainType, {
            'type': subType,
            'flow': flow || 'loyalty_registration',
            'data': {
                'error': [error],
                'rememberMe': rememberMe,
                'sessionExpired': sessionExpired
            }
        });
    }

    fireSpecificEventModeAnalyticsErrorEvent (mainType, subType, error, eventMode) {
        $('body').trigger('customer:' + mainType, {
            'type': subType,
            'eventMode': eventMode,
            'data': {
                'error': [error]
            }
        });
    }

    deleteAccount () {
        $(document).on('click', '.js-account-delete-button', function (e) {
            e.preventDefault();

            // Show popup
            const htmlContent = $('#accountDeleteConfirmModal').clone().html();
            // create and open confirmation modal
            const modal = newModalFromString(htmlContent, false, ['account-delete-tingle']);
            modal.open();
            $(modal.modalBox).on('click', '#accountDeleteConfirmModalNo, #accountDeleteCloseErrorModal', (e) => {
                e.preventDefault();
                modal.close();
                modal.destroy();
            });
            $(modal.modalBox).on('click', '.close, .btn-close, #accountDeleteCloseSuccessModal', (e) => {
                e.preventDefault();
                if (window.redirectToHomepageInsteadClosing) {
                    let redirectUrl = $('#accountDeleteHiddenHomeLink').attr('href');
                    window.location.replace(redirectUrl);
                    window.redirectToHomepageInsteadClosing = undefined;
                } else {
                    modal.close();
                    modal.destroy();
                }
            });
            $(modal.modalBox).on('click', '#accountDeleteConfirmModalYes', (e) => {
                e.preventDefault();
                // Ajax call to the account delete service
                var url = $('#accountDeleteConfirmModal').data('account-delete-url');
                $.spinner().start();
                $.ajax({
                    url: url,
                    method: 'GET',
                    success: data => {
                        if (data.error) {
                            onErrorHandler();
                        } else {
                            $('body').trigger('analytics:accountRemoveConfirmation');
                            $('.js-account-delete-ok').show();
                            $('.js-account-delete-error').hide();
                            window.redirectToHomepageInsteadClosing = true;
                            $('#accountCancellationModalStep1').addClass('account-temporary-hide');
                            $('#accountCancellationModalSuccess').removeClass('account-temporary-hide');
                            $.spinner().stop();
                        }
                    },
                    error: data => {
                        onErrorHandler();
                    }
                });
                function onErrorHandler () {
                    $('.js-account-delete-error').show();
                    $('#accountCancellationModalStep1').addClass('account-temporary-hide');
                    $('#accountCancellationModalError').removeClass('account-temporary-hide');
                    $.spinner().stop();
                }
            });
        });
    }

    accountLoginForm (fromLayer = false, rurlDynamic) {
        const _self = this;
        $('form.login').ready(function () {
            if (window.location.href.indexOf('force%2elogin') >= 0 || window.location.href.indexOf('force.login') >= 0 && $('#login-form-email').val() != null) {
                $('#login-form-error').html($('#login-error-label').text())
                    .addClass('is-invalid')
                    .addClass('success-block')
                    .siblings('.invalid-feedback')
                    // .html()
                    .show();
            }

            

            if (window.location.href.indexOf('tab.reg') >= 0 || window.location.href.indexOf('tab%2ereg') >= 0) {
                $('#tab-login-cell, .js-link-access').removeClass('current');
                $('#tab-registration-cell, .js-link-register').addClass('current');
                this.turnLoginImg();
            }
        });
        if($('.login-popup-footer-old').hasClass('hidden')) {
            $('.login-popup-footer-old').removeClass('hidden')
        }
        if(!$('.login-popup-footer-new').hasClass('hidden')) {
            $('.login-popup-footer-new').addClass('hidden');
        }

        $('form.login').submit(function (e) {
            var form = $(this);

            // Prevent standard login form submission if unified registration is active and we are on Step 1 (the email next button is visible)    
            if ($('.js-btn-email-next').is(':visible')) {
                e.preventDefault();
                e.stopImmediatePropagation();
                $('.js-btn-email-next').trigger('click');
                return false;
            }

            e.preventDefault();
            if (!checkRememberFlag(fromLayer)) {
                return;
            } else {
                toggleRememberPopover(fromLayer, false);
            }
            var url = form.attr('action');
            if (rurlDynamic && rurlDynamic.data('url')) {
                url = rurlDynamic.data('url');
            }
            if ($('.js-persistent-layer').length) {
                url += '&isPersistent=true';
            }
            $.spinner().start();

            var regFlowPosition;
            if (form.is('#unified-login-form')) {
                regFlowPosition = $('.js-unified-page-wrapper').length ? 'landing_page' : 'modal';
            }

            $('form.login').trigger('login:submit', e);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    form.spinner().stop();
                    if (!data.success) {
                        if (data.socialCustomer) {
                            socialLoginOpenForgotPasswordModal(data.email);
                        } else {
                            FormHelpers.init(form, data);
                            $('form.login').trigger('login:error', data);
                            $('#login-form-password').val('');
                            $('.cc-asterisk-pwd-wrapper #login-form-password').siblings('.js-asterisk-pwd-overlay').text('');
                            _self.fireGenericAnalyticsErrorEvent('login', 'step1_login', 'wrong_email_or_wrong_password');
                            _self.fireSpecificAnalyticsErrorEvent('login', 'login', 'wrong_email_or_wrong_password', data.rememberMe);
                            if (regFlowPosition) {
                                $('body').trigger('customer:login', {
                                    'type': 'login',
                                    'rememberMe': data.rememberMe,
                                    'data': { 'error': true },
                                    'regFlowPosition': regFlowPosition
                                });
                            }
                        }
                    } else {
                        $('form.login').trigger('login:success', data);
                        $('body').trigger('customer:login', {
                            'type': 'login',
                            'data': data,
                            'regFlowPosition': regFlowPosition
                        });

                        var isFirstLogin = data.isFirstLogin;
                        var loyaltySubscriptions = data.response && data.response.customerFidelitySubscriptions ? data.response.customerFidelitySubscriptions : [];
                        if (!isFirstLogin && !RegistrationHelper.isUserLoyaltyForThisBrand(loyaltySubscriptions) && RegistrationHelper.isLoyaltyAvailable()) {
                            $('.js-unified-modal-loyalty-registration').val('user-is-logged');
                            $('.js-unified-modal-loyalty-registration').trigger('click');
                            return;
                        } else if (!isFirstLogin && RegistrationHelper.isNewRegistrationActive() && !RegistrationHelper.isUserLoyaltyForThisBrand(loyaltySubscriptions) && RegistrationHelper.isLoyaltyAvailable()) {
                            $('.js-modal-loyalty-registration-fake').val('user-is-logged');
                            $('.js-modal-loyalty-registration-fake').trigger('click');
                            return;
                        }
                        if (isFirstLogin) {
                            location.href = data.redirectUrl;
                        } else if (fromLayer) {
                            location.reload();
                        } else {
                            location.href = data.redirectUrl;
                        }
                    }

                    if ($('#login-form-error .user-error-link').length > 0) {
                        $('.login-popup-footer-old').addClass('hidden');
                        $('.login-popup-footer-new').removeClass('hidden');
                    }
                },
                error: function (data) {
                    _self.fireGenericAnalyticsErrorEvent('login', 'step1_login', 'unknown_error');
                    $('body').trigger('customer:login', {
                        'type': 'login',
                        'data': { 'error': ['unknown_error'] },
                        'regFlowPosition': regFlowPosition
                    });

                    if (data.responseJSON.redirectUrl) {
                        window.location.href = data.responseJSON.redirectUrl;
                    } else {
                        $('form.login').trigger('login:error', data);
                        form.spinner().stop();
                    }
                }
            });
            return false;
        });

        $('.layer-login-modal .info-icon, #tab-login-cell .login-form-container .info-icon').find('span').on('click', function () {
            $('body').trigger('customer:persistentTooltip');
        });

        function enableLoginAnalyticsObserver () {
            let targetLoginNode = $('form.login:visible')[0];
            let config = { attributes: true, childList: true, subtree: true };
            let callback = function (mutationsList, observer) {
                let inputSet = new Set();
                let genericEventAlreadyFired = false;
                for (let index = 0; index < mutationsList.length; index++) {
                    let mutation = mutationsList[index];
                    if (mutation.type === 'attributes' &&
                        mutation.target.nodeName === 'INPUT' &&
                        mutation.attributeName === 'class' &&
                        mutation.target.classList.contains('is-invalid-input')) {
                        if (!inputSet.has(mutation.target.id)) {
                            let errorMsg = 'unknown_error';
                            if (mutation.target.id.includes('email')) {
                                errorMsg = mutation.target.value ? 'email_already_registered_in_existing_account' : 'empty_field_or_invalid_email';
                            } else if (mutation.target.id.includes('password-confirm')) {
                                errorMsg = mutation.target.value ? 'mismatch_password' : 'empty_password';
                            } else if (mutation.target.id.includes('password')) {
                                errorMsg = mutation.target.value ? 'wrong_email_or_wrong_password' : 'empty_password';
                            } else {
                                errorMsg = 'unknown_error';
                            }
                            let rememberMe = false;
                            let sessionExpired = false;
                            if ($('#rememberMe, .layer-login-modal #rememberMeTwo').length && $('#rememberMe,.layer-login-modal #rememberMeTwo').is(':checked')) {
                                rememberMe = true;
                            }
                            if ($('.js-persistent-layer').length) {
                                sessionExpired = true;
                            }
                            _self.fireGenericAnalyticsErrorEvent('login', 'step1_login', errorMsg);
                            if (!genericEventAlreadyFired) {
                                _self.fireSpecificAnalyticsErrorEvent('login', 'login', errorMsg, rememberMe, sessionExpired);
                                genericEventAlreadyFired = true;
                            }
                            inputSet.add(mutation.target.id);
                        }
                    }
                }
                observer.disconnect();
            };
            let observer = new MutationObserver(callback);
            observer.observe(targetLoginNode, config);
        }

        if ($('form.login').length > 0) {
            var submitButtonAnalytics = $('form.login').find('button[type=submit]:visible');
            if(submitButtonAnalytics.length === 0){
                submitButtonAnalytics = $('form.login:first').find('button[type=submit]');
            }
            submitButtonAnalytics.on('click', function (e) {
                enableLoginAnalyticsObserver();
            });
        }

        function socialLoginOpenForgotPasswordModal (email) {
            $('body').trigger('socialLoginError:standardCustomer');
            const htmlContent = $('#requestPasswordResetModal').clone().html();
            // create and open confirmation modal
            const modal = newModalFromString(htmlContent, false, ['layer-password-modal']);
            modal.open();
            _self.resetPasswordForm();
            $(modal.modalBox).find('.request-password-title').addClass('hidden');
            $(modal.modalBox).find('.social-request-password-title').removeClass('hidden');
            const socialTitle = $(modal.modalBox).find('.social-request-password-title').data('title');
            $(modal.modalBox).find('.social-request-password-title').text(socialTitle);
            $(modal.modalBox).find('.ico-center-send-mail').addClass('hidden');
            $(modal.modalBox).find('.request-password-body-description').addClass('hidden');
            $(modal.modalBox).find('.social-request-password-body-description').removeClass('hidden');
            $(modal.modalBox).find('#reset-password-email').val(email);
            $(modal.modalBox).on('click', '.close, .btn-close', (e) => {
                e.preventDefault();
                modal.close();
                modal.destroy();
            });
        }
    }

    loginAndAssociateOrderWithLoyaltyCustomer () {
        const _self = this;
        $('form.loginAndAssociateOrder').submit(function (e) {
            var form = $(this);
            e.preventDefault();
            var url = form.attr('action');
            $.spinner().start();

            $('form.loginAndAssociateOrder').trigger('login:submit', e);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    form.spinner().stop();
                    if (!data.success) {
                        FormHelpers.init(form, data);
                        $('loginAndAssociateOrder.login').trigger('login:error', data);
                        $('#login-form-password').val('');
                        $('.cc-asterisk-pwd-wrapper #login-form-password').siblings('.js-asterisk-pwd-overlay').text('');
                        _self.fireGenericAnalyticsErrorEvent('login', 'step1_login', 'wrong_email_or_wrong_password');
                        _self.fireSpecificAnalyticsErrorEvent('login', 'login', 'wrong_email_or_wrong_password');
                    } else {
                        // order association request
                        var associationForm = $('form.orderAssociation');
                        var url = associationForm.attr('action');
                        $('body').trigger('customer:login', {
                            'type': 'login',
                            'data': data
                        });
                        $.ajax({
                            url: url,
                            type: "post",
                            dataType: "json",
                            data: associationForm.serialize(),
                            success: function (data) {
                                if (data.success) {
                                    location.href = data.redirectUrl;
                                } else {
                                    // order can't be associated
                                    $('#login').prop('disabled',true);
                                    $('.login-form-error').addClass('hidden');
                                    $('#orderAssociationError').removeClass('hidden');
                                }
                            },
                            error: function (data) {
                                $('#login').prop('disabled',true);
                                $('.login-form-error').addClass('hidden');
                                $('#orderAssociationError').removeClass('hidden');
                                $('loginAndAssociateOrder.login').trigger('login:error', data);
                            }
                        });
                    }
                },
                error: function (data) {
                    $('body').trigger('customer:login', {
                        'type': 'login',
                        'data': ['unknown_error']
                    });
                    if (data.responseJSON.redirectUrl) {
                        window.location.href = data.responseJSON.redirectUrl;
                    } else {
                        $('loginAndAssociateOrder.login').trigger('login:error', data);
                        form.spinner().stop();
                    }
                }
            });
            return false;
        });

        function enableLoginAndAssociateAnalyticsObserver () {
            let targetLoginNode = $('form.loginAndAssociateOrder').get(0);
            let config = { attributes: true, childList: true, subtree: true };
            let callback = function (mutationsList, observer) {
                let inputSet = new Set();
                let genericEventAlreadyFired = false;
                for (let index = 0; index < mutationsList.length; index++) {
                    let mutation = mutationsList[index];
                    if (mutation.type === 'attributes' &&
                        mutation.target.nodeName === 'INPUT' &&
                        mutation.attributeName === 'class' &&
                        mutation.target.classList.contains('is-invalid-input')) {
                        if (!inputSet.has(mutation.target.id)) {
                            let errorMsg = 'unknown_error';
                            if (mutation.target.id.includes('email')) {
                                errorMsg = mutation.target.value ? 'email_already_registered_in_existing_account' : 'empty_field_or_invalid_email';
                            } else if (mutation.target.id.includes('password-confirm')) {
                                errorMsg = mutation.target.value ? 'mismatch_password' : 'empty_password';
                            } else if (mutation.target.id.includes('password')) {
                                errorMsg = mutation.target.value ? 'wrong_email_or_wrong_password' : 'empty_password';
                            } else {
                                errorMsg = 'unknown_error';
                            }
                            _self.fireGenericAnalyticsErrorEvent('login', 'step1_login', errorMsg);
                            if (!genericEventAlreadyFired) {
                                _self.fireSpecificAnalyticsErrorEvent('login', 'login', errorMsg);
                                genericEventAlreadyFired = true;
                            }
                            inputSet.add(mutation.target.id);
                        }
                    }
                }
                observer.disconnect();
            };
            let observer = new MutationObserver(callback);
            observer.observe(targetLoginNode, config);
        }

        if (document.querySelectorAll('form.loginAndAssociateOrder').length > 0) {
            let registrationStartFrom = document.querySelectorAll('form.loginAndAssociateOrder')[0];
            let submitButtonAnalytics = registrationStartFrom.querySelectorAll('button[type=submit]')[0];
            submitButtonAnalytics.addEventListener('click', function (e) {
                enableLoginAndAssociateAnalyticsObserver();
            });
        }
    }

    loginAndAssociateOrderWithCustomer () {
        const _self = this;
        $('form.loginAndAssociateOrderWithCustomer').submit(function (e) {
            var form = $(this);
            e.preventDefault();
            var url = form.attr('action');
            $.spinner().start();

            $('form.loginAndAssociateOrderWithCustomer').trigger('login:submit', e);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    form.spinner().stop();
                    if (!data.success) {
                        FormHelpers.init(form, data);
                        $('loginAndAssociateOrderWithCustomer.login').trigger('login:error', data);
                        $('#login-form-password').val('');
                        $('.cc-asterisk-pwd-wrapper #login-form-password').siblings('.js-asterisk-pwd-overlay').text('');
                        _self.fireGenericAnalyticsErrorEvent('login', 'step1_login', 'wrong_email_or_wrong_password');
                        _self.fireSpecificAnalyticsErrorEvent('login', 'login', 'wrong_email_or_wrong_password');
                    } else {
                        // order association request
                        var associationForm = $('form.orderAssociation');
                        var url = associationForm.attr('action');
                        $('body').trigger('customer:login', {
                            'type': 'login',
                            'data': data
                        });
                        $.ajax({
                            url: url,
                            type: "post",
                            dataType: "json",
                            data: associationForm.serialize(),
                            success: function (data) {
                                if (data.success) {
                                    $('.loginContainer').remove();
                                    if (RegistrationHelper.isLoyaltyAvailable()) {
                                        $('.js-unified-modal-loyalty-registration').val('user-is-logged');
                                        $('.js-unified-modal-loyalty-registration').trigger('click');
                                    } else {
                                        $('.loyaltyContainer').removeClass('hidden');
                                    }
                                    $('.analytics.helperData').data('user-id', data.hkCustomerId);
                                } else {
                                    // order can't be associated
                                    $('#login').prop('disabled',true);
                                    $('.login-form-error').addClass('hidden');
                                    $('#orderAssociationError').removeClass('hidden');
                                }
                            },
                            error: function (data) {
                                $('#login').prop('disabled',true);
                                $('.login-form-error').addClass('hidden');
                                $('#orderAssociationError').removeClass('hidden');
                                $('loginAndAssociateOrderWithCustomer.login').trigger('login:error', data);
                            }
                        });
                    }
                },
                error: function (data) {
                    $('body').trigger('customer:login', {
                        'type': 'login',
                        'data': ['unknown_error']
                    });
                    if (data.responseJSON.redirectUrl) {
                        window.location.href = data.responseJSON.redirectUrl;
                    } else {
                        $('loginAndAssociateOrderWithCustomer.login').trigger('login:error', data);
                        form.spinner().stop();
                    }
                }
            });
            return false;
        });

        function enableCustomerLoginAndAssociateAnalyticsObserver () {
            let targetLoginNode = $('form.loginAndAssociateOrderWithCustomer').get(0);
            let config = { attributes: true, childList: true, subtree: true };
            let callback = function (mutationsList, observer) {
                let inputSet = new Set();
                let genericEventAlreadyFired = false;
                for (let index = 0; index < mutationsList.length; index++) {
                    let mutation = mutationsList[index];
                    if (mutation.type === 'attributes' &&
                        mutation.target.nodeName === 'INPUT' &&
                        mutation.attributeName === 'class' &&
                        mutation.target.classList.contains('is-invalid-input')) {
                        if (!inputSet.has(mutation.target.id)) {
                            let errorMsg = 'unknown_error';
                            if (mutation.target.id.includes('email')) {
                                errorMsg = mutation.target.value ? 'email_already_registered_in_existing_account' : 'empty_field_or_invalid_email';
                            } else if (mutation.target.id.includes('password-confirm')) {
                                errorMsg = mutation.target.value ? 'mismatch_password' : 'empty_password';
                            } else if (mutation.target.id.includes('password')) {
                                errorMsg = mutation.target.value ? 'wrong_email_or_wrong_password' : 'empty_password';
                            } else {
                                errorMsg = 'unknown_error';
                            }
                            _self.fireGenericAnalyticsErrorEvent('login', 'step1_login', errorMsg);
                            if (!genericEventAlreadyFired) {
                                _self.fireSpecificAnalyticsErrorEvent('login', 'login', errorMsg);
                                genericEventAlreadyFired = true;
                            }
                            inputSet.add(mutation.target.id);
                        }
                    }
                }
                observer.disconnect();
            };
            let observer = new MutationObserver(callback);
            observer.observe(targetLoginNode, config);
        }

        if (document.querySelectorAll('form.loginAndAssociateOrderWithCustomer').length > 0) {
            let registrationStartFrom = document.querySelectorAll('form.loginAndAssociateOrderWithCustomer')[0];
            let submitButtonAnalytics = registrationStartFrom.querySelectorAll('button[type=submit]')[0];
            submitButtonAnalytics.addEventListener('click', function (e) {
                enableCustomerLoginAndAssociateAnalyticsObserver();
            });
        }
    }

    registerAndAssociateOrderForm () {
        const _self = this;
        $('form.registrationAndOrderAssociation').submit(function (e) {
            $('#registration-error-message').addClass('hidden');
            var form = $(this);
            e.preventDefault();
            var url = form.attr('action');
            $.spinner().start();

            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    form.spinner().stop();
                    if (!data.success) {
                        $('#registration-error-message').removeClass('hidden');
                        _self.fireSpecificAnalyticsErrorEvent('registerFirst', 'registration', 'email_or_number_already_registered');
                    } else {
                        $('body').trigger('customer:registerFirst', {
                            'type': 'registration',
                            'data': data
                        });
                        var redirectUrl = $('#loginPageURL').data('url') || data.redirectUrl;
                        location.href = redirectUrl;
                    }
                },
                error: function (data) {
                    form.spinner().stop();
                    $('#registration-error-message').removeClass('hidden');
                }
            });
            return false;
        });
    }

    prepareLoyaltySubscriptionForm () {
        $('button.prepareLoyaltySubscription').click(function (e) {
            $('#registration-error-message').addClass('hidden');
            var form = $('form.prepareLoyaltySubscription');
            e.preventDefault();
            var url = form.attr('action');
            $.spinner().start();

            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    form.spinner().stop();
                    if (!data.success) {
                        $('#registration-error-message').removeClass('hidden');
                        $('button.prepareLoyaltySubscription').remove();
                    } else {
                        $('body').trigger('analytics:prepareLoyaltySubscription');
                        location.href = data.redirectUrl;
                    }
                },
                error: function (data) {
                    form.spinner().stop();
                    $('#registration-error-message').removeClass('hidden');
                    $('button.prepareLoyaltySubscription').remove();
                }
            });
            return false;
        });
    }

    accountLoyaltyForm () {
        const _self = this;
        $('form.loyalty').submit(function (e) {
            var form = $(this);
            e.preventDefault();
            var url = form.attr('action');
            FormHelpers.clearPreviousErrors(form);
            $.spinner().start();
            $('form.registration').trigger('login:register', e);
            let stateObj = {
                foo: $('#backLinkObj').text()
            };
            history.pushState(stateObj, '', $('#backLink').text());
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    form.spinner().stop();
                    if (!data.success) {
                        FormHelpers.init(form, data);
                        if (data.fields) {
                            FormHelpers.loadFormErrors(form, data.fields);
                        }
                        if (data.alreadyRegistered) {
                            $('.already-registered-2').removeClass('login-form-error-block');
                            $('.already-registered-2').removeClass('color-alert');
                            $('.already-registered-2').addClass('is-invalid');
                            $('.already-registered-2').addClass('success-block');
                        }
                        _self.fireGenericAnalyticsErrorEvent('loyalty_card', 'loyalty_registration', 'step1_card', 'empty_or_invalid_card_code_or_card_pin');
                        _self.fireSpecificAnalyticsErrorEvent('registrationLoyaltyCardStep', 'loyalty_registration', 'loyalty_card', 'empty_or_invalid_card_code_or_card_pin');
                    } else {
                        if (data.error) delete data.error;
                        $('body').trigger('customer:registrationLoyaltyCardStep', {
                            'type': 'registration',
                            'data': data,
                            'flow': 'loyalty_registration'
                        });
                        if (RegistrationHelper.isRegistrationModalFlow()) {
                            var customerInfo = data.customerInfo;
                            var nextStep = data.modalRegistrationStep;
                            /* if (nextStep === 'email') {
                                $('#register-loyalty').addClass('hidden');
                                if (customerInfo) {
                                    RegistrationHelper.handleCustomerInfo(customerInfo);
                                    if (customerInfo.mobileNumber !== '') {
                                        $('.registrationModal-box').attr('data-registration-modal-skip-phone', 'true');
                                        $('.registrationModal-box').attr('data-skipped-phone', customerInfo.mobileNumber);
                                    }
                                    $('.policy-promotion-loyalty').addClass('hidden');
                                } else {
                                    $('.loyalty-flag').trigger('click');
                                }
                            } */
                            if (nextStep === 'email_only') {
                                RegistrationHelper.moveToNextStep(nextStep);
                                $('.loyalty-flag').trigger('click');
                                $('.policy-promotion-loyalty').addClass('hidden');
                            } else {
                                RegistrationHelper.moveToNextStep(nextStep);
                                RegistrationHelper.handleCustomerInfo(customerInfo);
                            }
                            if (nextStep === 'personal-info') {
                                $('.js-back-step-arrow').addClass('hidden');
                                $('.policy-promotion-loyalty').addClass('hidden');
                            } else if (nextStep === 'phone') {
                                $('.policy-promotion-loyalty').addClass('hidden');
                            }
                            $('.rightModalAttribute').scrollTop(0);
                        } else {
                            location.href = data.redirectUrl;
                        }
                        // FormHelpers.init(form, data);
                        // if (data.fields) {
                        //     FormHelpers.loadFormErrors(form, data.fields);
                        // }
                    }
                },
                error: function (data) {
                    _self.fireGenericAnalyticsErrorEvent('registration', 'step1_loyalty_card', 'generic_error');
                    // if (data.responseJSON.redirectUrl) {
                    //     window.location.href = data.responseJSON.redirectUrl;
                    // }
                    form.spinner().stop();
                }
            });
            return false;
        });

        const config = { attributes: true, childList: true, subtree: true };
        function enableLoyaltyAnalyticsObserver () {
            let targetLoyaltyNode = $('form.loyalty').get(0);
            let loyaltyCallback = function (mutationsList, observer) {
                let inputSet = new Set();
                let genericEventAlreadyFired = false;
                for (let index = 0; index < mutationsList.length; index++) {
                    let mutation = mutationsList[index];
                    if (mutation.type === 'attributes' &&
                        mutation.target.nodeName === 'INPUT' &&
                        mutation.attributeName === 'class' &&
                        mutation.target.classList.contains('is-invalid-input')) {
                        if (!inputSet.has(mutation.target.id)) {
                            let errorMsg = 'unknown_error';
                            let step = 'step1_card';
                            if (mutation.target.id.includes('cardCode')) {
                                errorMsg = mutation.target.value ? 'wrong_card_code' : 'empty_card_code';
                            } else if (mutation.target.id.includes('cardPin')) {
                                errorMsg = mutation.target.value ? 'wrong_card_pin' : 'empty_card_pin';
                            } else {
                                errorMsg = 'unknown_error';
                            }

                            _self.fireGenericAnalyticsErrorEvent('loyalty_card', step, errorMsg);
                            if (!genericEventAlreadyFired) {
                                $('body').trigger('customer:registrationLoyaltyCardStep', {
                                    'type': 'loyalty_card',
                                    'flow': 'loyalty_registration',
                                    'data': {
                                        'error': [errorMsg]
                                    }
                                });
                                genericEventAlreadyFired = true;
                            }

                            inputSet.add(mutation.target.id);
                        }
                    }
                }
                loyaltyObserver.disconnect();
            };
            let loyaltyObserver = new MutationObserver(loyaltyCallback);
            loyaltyObserver.observe(targetLoyaltyNode, config);
        }

        if (document.querySelectorAll('form.loyalty').length > 0) {
            let registrationStartFrom = document.querySelectorAll('form.loyalty')[0];
            let submitButtonAnalytics = registrationStartFrom.querySelectorAll('button[type=submit]')[0];
            submitButtonAnalytics.addEventListener('click', function (e) {
                enableLoyaltyAnalyticsObserver();
            });
        }
    };

    accountRegisterForm () {
        const _self = this;
        $('form.registration').ready(function () {
            if ($('#login-warn-label').text().length > 2) {
                $('#reg-phone-error').html($('#login-warn-label').text())
                    .addClass('is-invalid')
                    .siblings('.invalid-feedback')
                    // .html()
                    .show();
                $('#reg-phone-error').addClass('success-block');
                $('#reg-phone-error').removeClass('color-alert');
            }
        });

        $('form.registrationStart').ready(function () {
            if ($('#login-warn-label').text().length > 2) {
                $('#reg-mail-error').html($('#login-warn-label').text())
                    .addClass('is-invalid')
                    .siblings('.invalid-feedback')
                    // .html()
                    .show();
                $('#reg-mail-error').addClass('success-block');
                $('#reg-mail-error').removeClass('color-alert');
            }
        });

        $('body').on('change', '.loyalty-flag', function (e) {
            var isChecked = $(e.currentTarget).prop('checked');
            if (isChecked) {
                $('.dob').removeClass('hidden');
                $('.opposition').removeClass('hidden');
                $('.warning-card-override').removeClass('hidden');
                $('.warning-card-override').addClass('success-block');
                $('.dob').prop('required', true);
                $('.button-register-final').data('loyalty-check', true);

                if (!$('.popover-loyalty-member-clz').hasClass('hidden')) {
                    toggleLoyaltyPopover(false);
                }
            } else {
                $('.dob').addClass('hidden');
                $('.opposition').addClass('hidden');
                $('.warning-card-override').addClass('hidden');
                $('.warning-card-override').removeClass('success-block');
                $('.dob').removeAttr('required');
                $('.button-register-final').data('loyalty-check', false);
            }
        });

        $('.add-to-email').on('change', (e) => {
            $('.js-personalized-news-container').removeClass('transparent');
            if (e.target.id === 'add-to-email-list-yes' && e.target.checked) {
                $('.add-to-personalized-list').prop('disabled', false);
                if (e.target.value != null && e.target.value) {
                    $('.add-to-personalized-list').prop('required', true);
                } else {
                    $('.add-to-personalized-list').removeAttr('required');
                }
            } else {
                $('.add-to-personalized-list').prop('checked', false);
                $('.add-to-personalized-list').prop('disabled', true);
                $('.add-to-personalized-list').removeAttr('required');
                $('.js-personalized-news-container').addClass('transparent');
            }
        });

        var enableCTA = (e) => {
            // My Account page new flow
            var isMyAccountPage = $('.registration-loyalty').data('myaccount-page') || false;
            if (isMyAccountPage) {
                _self.handleMyAccountFlow();
                return;
            }

            var loyalty = $('.loyalty-flag-m:checked').val() !== undefined && $('.loyalty-flag-m:checked').val() == 'true';
            var loyaltyPhysicalCard = $('.associate-loyalty-flag-m:checked').val() !== undefined && $('.associate-loyalty-flag-m:checked').val() == 'true';
            var cardValues = $('#loyalty-form-cardCode').val() != '' && $('#loyalty-form-cardPin').val() != '';
            cardValues = cardValues && $('#loyalty-form-cardCode').val().length >= $('#loyalty-form-cardCode').attr('minlength');
            cardValues = cardValues && $('#loyalty-form-cardPin').val().length >= $('#loyalty-form-cardPin').attr('minlength');

            $('.disabledForm').prop('disabled', true);
            $('.block-associate-card').hide();

            if (loyaltyPhysicalCard) {
                $('.block-associate-card').show();
            }

            if (loyalty) {
                if (loyaltyPhysicalCard && cardValues && $('.associate-loyalty-flag-m:checked').val() !== undefined) {
                    $('.disabledForm').prop('disabled', false);
                }
                else if (!loyaltyPhysicalCard && $('.associate-loyalty-flag-m:checked').val() !== undefined){
                    $('.disabledForm').prop('disabled', false);
                }
            }
        };

        var clearInput = (e) => {
            $(e.target).removeClass('is-input-invalid');
        };

        $('.loyalty-flag-m, .associate-loyalty-flag-m').on('change', enableCTA);
        $('#loyalty-form-cardCode, #loyalty-form-cardPin, .myaccount-date-picker-input').on('keyup', enableCTA);
        $('.myaccount-date-picker').on('changeDate', enableCTA);
        $('#loyalty-form-cardCode, #loyalty-form-cardPin').on('keydown', clearInput);

        $(document).on('click', '.sendNewOtp', function (e) {
            e.preventDefault();
            $('#registration-form-phone-confirm').val('');
            $('#registration-form-phone-confirm').attr('required', false);
            $('form.registration').submit();
        });

        $('form.registration').off('submit.loyaltyForm').on('submit.loyaltyForm', function (e) {
            if ($(this).hasClass('js-unified-registration-step-final')) {
                return;
            }

            e.preventDefault();

            var form = $(this);
            var $submitBtn = form.find('button[type="submit"]');

            if (form.data('in-flight')) {
                return false;
            }

            if ($submitBtn.is(':disabled')) {
                return false;
            }

            if (!checkLoyaltyFlag()) {
                return;
            }

            form.data('in-flight', true);
            $submitBtn.prop('disabled', true).attr('aria-busy', 'true');
            var url = form.attr('action');
            FormHelpers.clearPreviousErrors(form);
            $.spinner().start();
            $('form.registration').trigger('login:register', e);
            var dataForm = form.serialize();
            if (RegistrationHelper.isRegistrationModalFlow()) {
                dataForm += '&isModalFlow=true';
            }
            if (RegistrationHelper.isRegistrationModalFlow() && $('.registrationModal-box').attr('data-registration-modal-skip-phone') === 'true') {
                var phoneNumber = $('.registrationModal-box').attr('data-skipped-phone');
                var prefix = $('#registration-form-prefix').val();
                phoneNumber = phoneNumber.substring(prefix.length);
                var phoneNumberText = '&associatedPhoneNumber=' + phoneNumber + '&associatedPrefix=' + prefix;
                dataForm += phoneNumberText;
            }
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: dataForm,
                success: function (data) {
                    form.spinner().stop();
                    if (!data.success) {
                        form.data('in-flight', false);
                        $submitBtn.removeAttr('aria-busy');

                        if (data.cardError) {
                            $('.card-error').html(data.error);
                            $('.card-error').removeClass('hide');
                            $('.login-form-error-block').html('');
                            $('#loyalty-form-cardCode, #loyalty-form-cardPin').addClass('is-invalid-input');
                            $('.disabledForm').prop('disabled', true);
                        } else if (data.phone2Opt) {
                            $('.registerPhoneButton').prop('disabled', true);
                            $('.registration-phone-confirm-block').addClass('2OptFlow');
                            $('.registration-phone-confirm-block').removeClass('hide');
                            $('#registration-form-phone-confirm').attr('required', true);
                            $('.login-form-error').html('').removeClass('login-form-error-block');
                            $('#reg-phone-error').addClass('hide');
                            if (data.error && data.error.length) {
                                $('#reg-phone-otp-error').html(data.error)
                                    .addClass('is-invalid')
                                    .siblings('.invalid-feedback')
                                    .show();
                                $('#reg-phone-otp-error').addClass('color-alert');
                                $('#reg-phone-otp-error').addClass('login-form-error-block');
                                $('#reg-phone-otp-error').removeClass('success-block');
                            }
                        } else {
                            $submitBtn.prop('disabled', false);
                            $('.card-error').addClass('hide');
                            FormHelpers.init(form, data);
                            let errorMsg = 'email_or_number_already_registered';
                            if (data.fields) {
                                FormHelpers.loadFormErrors(form, data.fields);
                                if ($('.birthdate-error')) {
                                    $('.birthdate-error').html(data.birthDateError);
                                    errorMsg = 'wrong_date_of_birth';
                                }
                            }
                            if ($('.page').data('action') === 'Account-RegistrationPhoneShow') {
                                errorMsg = 'inserted_number_different_from_stored_number';
                            }
                            if ($('.page').data('action') === 'Account-RegistrationFormShow') {
                                if ($('#loyaltyRegistration').length > 0) {
                                    _self.fireGenericAnalyticsErrorEvent('loyalty_card', 'step4_personal_data', errorMsg);
                                    _self.fireSpecificEventModeAnalyticsErrorEvent(
                                        'registrationLoyaltyStep4', 'loyalty_card', errorMsg, 'phone');
                                } else if ($('#socialRegistration').length > 0) {
                                    _self.fireGenericAnalyticsErrorEvent('social_registration', 'step3_personal_data', errorMsg);
                                    _self.fireSpecificAnalyticsErrorEvent('registerSocialThird', 'social_registration', errorMsg);
                                } else {
                                    _self.fireGenericAnalyticsErrorEvent('registration', 'step3_personal_data', errorMsg);
                                    _self.fireSpecificAnalyticsErrorEvent('registerThird', 'registration', errorMsg);
                                }
                            } else {
                                if ($('#loyaltyRegistration').length > 0) {
                                    _self.fireGenericAnalyticsErrorEvent('loyalty_card', 'step3_phone', errorMsg);
                                    _self.fireSpecificEventModeAnalyticsErrorEvent(
                                        'registrationLoyaltyStep3', 'loyalty_card', errorMsg, 'phone');
                                } else if ($('#socialRegistration').length > 0) {
                                    _self.fireGenericAnalyticsErrorEvent('social_registration', 'step2_phone', errorMsg);
                                    _self.fireSpecificAnalyticsErrorEvent('registerSocialSecond', 'social_registration', errorMsg);
                                } else {
                                    _self.fireGenericAnalyticsErrorEvent('registration', 'step2_phone', errorMsg);
                                    _self.fireSpecificAnalyticsErrorEvent('registerSecond', 'registration', errorMsg);
                                }
                            }
                        }

                        if ($('#login-error-label').text() && !data.phone2Opt) {
                            $('#reg-phone-error').html(data.error.text())
                                .addClass('is-invalid')
                                .siblings('.invalid-feedback')
                                // .html()
                                .show();
                            $('#reg-phone-error').addClass('color-alert');
                            $('#reg-phone-error').addClass('login-form-error-block');
                            $('#reg-phone-error').removeClass('success-block');
                        }
                    } else {
                        if ($(e.currentTarget).hasClass('registration-step-final')) {
                            let rememberMe = $('.remember-me-container input#rememberMeTwo').is(':checked');
                            let analyticsMode = 'only_registration';
                            if (data.error) delete data.error;
                            if ($('#loyaltyRegistration').length > 0) {
                                analyticsMode = 'profile_loyalty';
                                data.type_reg = analyticsMode;
                                $('body').trigger('customer:registrationLoyaltyStep4', {
                                    'type': 'loyalty_card',
                                    'data': data,
                                    rememberMe
                                });
                            } else if ($('#socialRegistration').length > 0) {
                                $('body').trigger('customer:registerSocialThird', { rememberMe });
                            } else {
                                analyticsMode = 'only_registration';
                                data.type_reg = analyticsMode;
                                $('body').trigger('customer:registerThird', {
                                    'analyticsMode': analyticsMode,
                                    rememberMe
                                });
                            }
                        } else if ($(e.currentTarget).hasClass('registration-loyalty')) {
                            let analyticsMode = 'fast_flow_with_physical_loyalty card';
                            if ($('.page').data('action') === 'Account-Loyalty' || RegistrationHelper.isRegistrationLoyaltyModalFlow()) {
                                analyticsMode = 'only_loyalty';
                            }
                            $('body').trigger('customer:registerLoyalty', analyticsMode);
                        } else {
                            if ($('#loyaltyRegistration').length > 0) {
                                $('body').trigger('customer:registrationLoyaltyStep3', {
                                    'type': 'loyalty_card',
                                    'eventMode': 'phone'
                                });
                            } else if ($('#socialRegistration').length > 0) {
                                $('body').trigger('customer:registerSocialSecond');
                            } else {
                                $('body').trigger('customer:registerSecond', {'type': 'registration'});
                            }
                        }
                        if (RegistrationHelper.isRegistrationModalFlow()) {
                            var nextStep = $(e.currentTarget).hasClass('registration-step-final') ? 'waiting-room' : 'personal-info';
                            var phone = $('#registration-form-phone').val();
                            RegistrationHelper.fillPhoneText(phone);
                            RegistrationHelper.moveToNextStep(nextStep);

                            if (nextStep === 'personal-info') {
                                $.ajax({
                                    url: data.redirectUrl,
                                    type: 'get',
                                    dataType: 'json',
                                    data: dataForm,
                                    success: function (data) {
                                        RegistrationHelper.fieldsFormPrefill(data);
                                    },
                                    error: function (err) {
                                        if (err.responseJSON) {
                                            $('#login-error-label').text(err.responseJSON.message).removeClass('hidden');
                                        } else {
                                            $('#login-error-label').text(err.statusText).removeClass('hidden');
                                        }
                                    }
                                });
                            }
                        } else if (RegistrationHelper.isRegistrationLoyaltyModalFlow()) {
                            $('#registrationModal-box').attr('data-registration-modal-stage', 'loyalty-thankyou-page');
                        } else {
                            location.href = data.redirectUrl;
                        }
                        // FormHelpers.init(form, data);
                        // if (data.fields) {
                        //     FormHelpers.loadFormErrors(form, data.fields);
                        // }
                    }
                },
                error: function (data) {
                    if (!data || !data.responseJSON || !data.responseJSON.redirectUrl) {
                        form.data('in-flight', false);
                        $submitBtn.prop('disabled', false).removeAttr('aria-busy');
                    }
                    if ($('#login-error-label').text()) {
                        _self.fireGenericAnalyticsErrorEvent('registration', 'step2_phone', 'generic_error');
                        _self.fireSpecificAnalyticsErrorEvent('registerSecond', 'registration', 'generic_error');
                    } else if ($(e.currentTarget).hasClass('registration-loyalty')) {
                        _self.fireGenericAnalyticsErrorEvent('loyalty_card', 'step3_personal_data', 'generic_error');
                        _self.fireSpecificAnalyticsErrorEvent('registerSecond', 'loyalty_card', 'generic_error');
                    } else {
                        _self.fireGenericAnalyticsErrorEvent('registration', 'step3_personal_data', 'generic_error');
                        $('body').trigger('customer:registerThird', {
                            'analyticsMode': 'only_registration',
                            'data': {
                                'error': ['generic_error']
                            }
                        });
                    }
                    if (data && data.responseJSON && data.responseJSON.redirectUrl) {
                        window.location.href = data.responseJSON.redirectUrl;
                    }
                    form.spinner().stop();
                }
            });
            return false;
        });

        $('form.registrationStart').submit(function (e) {
            var form = $(this);
            e.preventDefault();
            var url = form.attr('action');
            FormHelpers.clearPreviousErrors(form);
            $.spinner().start();
            $('form.registration').trigger('login:register', e);
            let stateObj = {
                foo: $('#backLinkObj').text()
            };
            history.pushState(stateObj, '', $('#backLink').text());
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    form.spinner().stop();
                    if (!data.success) {
                        FormHelpers.init(form, data);
                        if (data.fields) {
                            FormHelpers.loadFormErrors(form, data.fields);
                        }
                        if (data.bluColor) {
                            RegistrationHelper.closeRegistrationOpenLoginInit();
                            $('.already-registered-1').removeClass('login-form-error-block');
                            $('.already-registered-1').removeClass('color-alert');
                            $('.already-registered-1').addClass('is-invalid');
                            $('.already-registered-1').addClass('success-block');
                            if ($('#loyaltyRegistration').length > 0) {
                                _self.fireGenericAnalyticsErrorEvent('loyalty_card', 'step2_email', 'email_or_number_already_registered');
                                _self.fireSpecificEventModeAnalyticsErrorEvent(
                                    'registrationLoyaltyStep2', 'loyalty_card', 'email_or_number_already_registered', 'email');
                            } else if ($('#socialRegistration').length > 0) {
                                _self.fireGenericAnalyticsErrorEvent('social_registration', 'step1_email', 'email_or_number_already_registered');
                                _self.fireSpecificAnalyticsErrorEvent('registerSocialFirst', 'social_registration', 'email_or_number_already_registered');
                            } else {
                                _self.fireGenericAnalyticsErrorEvent('registration', 'step1_email', 'email_or_number_already_registered');
                                _self.fireSpecificAnalyticsErrorEvent('registerFirst', 'registration', 'email_or_number_already_registered');
                            }
                        } else {
                            if ($('#loyaltyRegistration').length > 0) {
                                _self.fireGenericAnalyticsErrorEvent('loyalty_card', 'step2_email', 'email_or_number_already_registered');
                                _self.fireSpecificEventModeAnalyticsErrorEvent(
                                    'registrationLoyaltyStep2', 'loyalty_card', 'email_or_number_already_registered', 'email');
                            } else if ($('#socialRegistration').length > 0) {
                                _self.fireGenericAnalyticsErrorEvent('social_registration', 'step1_email', 'email_or_number_already_registered');
                                _self.fireSpecificAnalyticsErrorEvent('registerSocialFirst', 'social_registration', 'email_or_number_already_registered');
                            } else {
                                _self.fireGenericAnalyticsErrorEvent('registration', 'step1_email', 'email_or_number_already_registered');
                                _self.fireSpecificAnalyticsErrorEvent('registerFirst', 'registration', 'email_or_number_already_registered');
                            }
                        }
                        if (data.socialRegistrationError) {
                            $('#reg-mail-error').addClass('color-alert');
                            $('#reg-mail-error').addClass('login-form-error-block');
                            $('#reg-mail-error').removeClass('success-block');
                        }
                        // else {
                        //     $('.already-registered-1').addClass('login-form-error-block');
                        //     $('.already-registered-1').addClass('color-alert');
                        //     $('.already-registered-1').removeClass('is-invalid');
                        //     $('.already-registered-1').removeClass('success-block');
                        // }
                    } else {
                        if (data.error) delete data.error;
                        if ($('#loyaltyRegistration').length > 0) {
                            $('body').trigger('customer:registrationLoyaltyStep2', {
                                'type': 'login',
                                'eventMode': 'email',
                                'data': data
                            });
                        } else if ($('#socialRegistration').length > 0) {
                            $('body').trigger('customer:registerSocialFirst', {
                                'type': 'social_registration',
                                'data': data
                            });
                        } else {
                            $('body').trigger('customer:registerFirst', {
                                'type': 'registration',
                                'data': data
                            });
                        }
                        if (RegistrationHelper.isRegistrationModalFlow()) {
                            var email = data.registrationFormObj.emailFromForm;
                            RegistrationHelper.fillEmailText(email);
                            RegistrationHelper.moveToNextStep('phone');
                            if (data.hiddenPhonePlaceholder) {
                                RegistrationHelper.handleExistingAccount(data);
                            }
                        } else {
                            location.href = data.redirectUrl;
                        }
                        // FormHelpers.init(form, data);
                        // if (data.fields) {
                        //     FormHelpers.loadFormErrors(form, data.fields);
                        // }
                    }
                },
                error: function (data) {
                    if ($('.loyalty-step1').length > 0) {
                        _self.fireGenericAnalyticsErrorEvent('loyalty_card', 'step1', 'generic_error');
                    } else {
                        _self.fireGenericAnalyticsErrorEvent('registration', 'step1', 'generic_error');
                        _self.fireSpecificAnalyticsErrorEvent('registerFirst', 'registration', 'generic_error');
                    }

                    if (data.responseJSON.redirectUrl) {
                        window.location.href = data.responseJSON.redirectUrl;
                    }
                    form.spinner().stop();
                }
            });
            return false;
        });

        const config = { attributes: true, childList: true, subtree: true };
        function enableRegistrationStartAnalyticsObserver () {
            let targetRegistrationStep1Node = $('form.registrationStart').get(0);
            let registrationStep1Callback = function (mutationsList, observer) {
                let inputSet = new Set();
                let genericEventAlreadyFired = false;
                for (let index = 0; index < mutationsList.length; index++) {
                    let mutation = mutationsList[index];
                    if (mutation.type === 'attributes' &&
                        mutation.target.nodeName === 'INPUT' &&
                        mutation.attributeName === 'class' &&
                        mutation.target.classList.contains('is-invalid-input')) {
                        if (!inputSet.has(mutation.target.id)) {
                            let errorMsg = 'unknown_error';
                            if (mutation.target.id.includes('email')) {
                                errorMsg = 'empty_or_invalid_email';
                            } else {
                                errorMsg = 'unknown_error';
                            }
                            if ($('#loyaltyRegistration').length > 0) {
                                _self.fireGenericAnalyticsErrorEvent('loyalty_card', 'step2_email', errorMsg);
                                if (!genericEventAlreadyFired) {
                                    _self.fireSpecificEventModeAnalyticsErrorEvent('registrationLoyaltyStep2', 'loyalty_card', errorMsg, 'email');
                                    genericEventAlreadyFired = true;
                                }
                            } else if ($('#socialRegistration').length > 0) {
                                _self.fireGenericAnalyticsErrorEvent('social_registration', 'step1_email', errorMsg);
                                if (!genericEventAlreadyFired) {
                                    _self.fireSpecificAnalyticsErrorEvent('registerSocialFirst', 'social_registration', errorMsg);
                                    genericEventAlreadyFired = true;
                                }
                            } else {
                                _self.fireGenericAnalyticsErrorEvent('registration', 'step1_email', errorMsg);
                                if (!genericEventAlreadyFired) {
                                    _self.fireSpecificAnalyticsErrorEvent('registerFirst', 'registration', errorMsg);
                                    genericEventAlreadyFired = true;
                                }
                            }

                            inputSet.add(mutation.target.id);
                        }
                    }
                }
                registrationStep1Observer.disconnect();
            };
            let registrationStep1Observer = new MutationObserver(registrationStep1Callback);
            registrationStep1Observer.observe(targetRegistrationStep1Node, config);
        }

        function enablePhoneRegistrationAnalyticsObserver () {
            var generalTrackingEventAlreadyTriggered = false;
            let targetRegistrationNode = $('form.registration').get(0);
            let registrationCallback = function (mutationsList, observer) {
                let inputSet = new Set();
                for (let index = 0; index < mutationsList.length; index++) {
                    if (index === 0) generalTrackingEventAlreadyTriggered = false;
                    let mutation = mutationsList[index];
                    if (mutation.type === 'attributes' &&
                        mutation.target.nodeName === 'INPUT' &&
                        mutation.attributeName === 'class' &&
                        mutation.target.classList.contains('is-invalid-input')) {
                        if (!inputSet.has(mutation.target.id)) {
                            let errorMsg = 'unknown_error';
                            if (mutation.target.id.includes('phone')) {
                                errorMsg = 'empty_or_invalid_phone_number';
                            } else if (mutation.target.id.includes('prefix')) {
                                errorMsg = 'empty_or_invalid_prefix_number';
                            }
                            if ($('#loyaltyRegistration').length > 0) {
                                _self.fireGenericAnalyticsErrorEvent('loyalty_card', 'step3_phone', errorMsg);
                                if (!generalTrackingEventAlreadyTriggered) {
                                    _self.fireSpecificEventModeAnalyticsErrorEvent('registrationLoyaltyStep3', 'loyalty_card', errorMsg, 'phone');
                                    generalTrackingEventAlreadyTriggered = true;
                                }
                            } else if ($('#socialRegistration').length > 0) {
                                _self.fireGenericAnalyticsErrorEvent('social_registration', 'step2_phone', errorMsg);
                                if (!generalTrackingEventAlreadyTriggered) {
                                    _self.fireSpecificAnalyticsErrorEvent('registerSocialSecond', 'social_registration', errorMsg);
                                    generalTrackingEventAlreadyTriggered = true;
                                }
                            } else {
                                _self.fireGenericAnalyticsErrorEvent('registration', 'step2_phone', errorMsg);
                                if (!generalTrackingEventAlreadyTriggered) {
                                    _self.fireSpecificAnalyticsErrorEvent('registerSecond', 'registration', errorMsg);
                                    generalTrackingEventAlreadyTriggered = true;
                                }
                            }
                            inputSet.add(mutation.target.id);
                        }
                    }
                }
                registrationObserver.disconnect();
            };
            let registrationObserver = new MutationObserver(registrationCallback);
            registrationObserver.observe(targetRegistrationNode, config);
        }

        function enableFinalRegistrationAnalyticsObservers () {
            var generalTrackingEventAlreadyTriggered = false;
            let targetRegistrationNode = $('form.registration').get(0);
            let registrationCallback = function (mutationsList, observer) {
                let inputSet = new Set();
                for (let index = 0; index < mutationsList.length; index++) {
                    if (index === 0) generalTrackingEventAlreadyTriggered = false;
                    let mutation = mutationsList[index];
                    if (mutation.type === 'attributes' &&
                        mutation.target.nodeName === 'INPUT' &&
                        mutation.attributeName === 'class' &&
                        mutation.target.classList.contains('is-invalid-input')) {
                        if (!inputSet.has(mutation.target.id)) {
                            let errorMsg = 'unknown_error';
                            if (mutation.target.id.includes('fname')) {
                                errorMsg = mutation.target.value ? 'wrong_firstname' : 'empty_firstname';
                            } else if (mutation.target.id.includes('lname')) {
                                errorMsg = mutation.target.value ? 'wrong_lastname' : 'empty_lastname';
                            } else if (mutation.target.id.includes('password-confirm')) {
                                errorMsg = mutation.target.value ? 'mismatch_password' : 'empty_password';
                            } else if (mutation.target.id.includes('password')) {
                                errorMsg = mutation.target.value ? 'wrong_password' : 'empty_password';
                            } else if (mutation.target.id.includes('dpReg')) {
                                errorMsg = mutation.target.value ? 'wrong_date_of_birth' : 'empty_date_of_birth';
                            }

                            if ($('#loyaltyRegistration').length > 0) {
                                _self.fireGenericAnalyticsErrorEvent('loyalty_card', 'step4_personal_data', errorMsg);
                                if (!generalTrackingEventAlreadyTriggered) {
                                    _self.fireSpecificAnalyticsErrorEvent('registrationLoyaltyStep4', 'loyalty_card', errorMsg);
                                    generalTrackingEventAlreadyTriggered = true;
                                }
                            } else if ($('#socialRegistration').length > 0) {
                                _self.fireGenericAnalyticsErrorEvent('social_registration', 'step3_personal_data', errorMsg);
                                if (!generalTrackingEventAlreadyTriggered) {
                                    _self.fireSpecificAnalyticsErrorEvent('registerSocialThird', 'social_registration', errorMsg);
                                    generalTrackingEventAlreadyTriggered = true;
                                }
                            } else {
                                _self.fireGenericAnalyticsErrorEvent('registration', 'step3_personal_data', errorMsg);
                                if (!generalTrackingEventAlreadyTriggered) {
                                    $('body').trigger('customer:registerThird', {
                                        'analyticsMode': 'only_registration',
                                        'data': {
                                            'error': [errorMsg]
                                        }
                                    });
                                    generalTrackingEventAlreadyTriggered = true;
                                }
                            }
                            inputSet.add(mutation.target.id);
                        }
                    }
                }
                registrationObserver.disconnect();
            };
            let registrationObserver = new MutationObserver(registrationCallback);
            registrationObserver.observe(targetRegistrationNode, config);

            let alreadyTriggeredOnceForPrivacy = false;

            let targetEmailPrivacyFlagsNode = $('#add-to-email-list-yes').parent().parent().get(0);
            let privacyFlagsCallback = function (mutationsList, observer) {
                let alreadyTriggeredOnce = false;
                for (let index = 0; index < mutationsList.length; index++) {
                    let mutation = mutationsList[index];
                    if (mutation.type === 'attributes' &&
                        mutation.target.nodeName === 'LABEL' &&
                        mutation.attributeName === 'class' &&
                        mutation.target.classList.contains('is-invalid-input')) {
                        if (!alreadyTriggeredOnce && !alreadyTriggeredOnceForPrivacy) {
                            if ($('#loyaltyRegistration').length > 0) {
                                _self.fireGenericAnalyticsErrorEvent('loyalty_card', 'step4_personal_data', 'empty_flag_privacy');
                                if (!generalTrackingEventAlreadyTriggered) {
                                    _self.fireSpecificAnalyticsErrorEvent('registrationLoyaltyStep4', 'loyalty_card', 'empty_flag_privacy');
                                    generalTrackingEventAlreadyTriggered = true;
                                }
                            } else if ($('#socialRegistration').length > 0) {
                                _self.fireGenericAnalyticsErrorEvent('social_registration', 'step3_personal_data', 'empty_flag_privacy');
                                if (!generalTrackingEventAlreadyTriggered) {
                                    _self.fireSpecificAnalyticsErrorEvent('registerSocialThird', 'social_registration', 'empty_flag_privacy');
                                    generalTrackingEventAlreadyTriggered = true;
                                }
                            } else {
                                if (!generalTrackingEventAlreadyTriggered) {
                                    $('body').trigger('customer:registerThird', {'status': 'error'});
                                    _self.fireSpecificAnalyticsErrorEvent('registerThirdError', 'registration', 'empty_flag_privacy');
                                    generalTrackingEventAlreadyTriggered = true;
                                }
                                _self.fireGenericAnalyticsErrorEvent('registration', 'step3_personal_data', 'empty_flag_privacy');
                            }
                            alreadyTriggeredOnce = true;
                            alreadyTriggeredOnceForPrivacy = true;
                        }
                    }
                }
                privacyFlagsObserver.disconnect();
            };
            let privacyFlagsObserver = new MutationObserver(privacyFlagsCallback);
            privacyFlagsObserver.observe(targetEmailPrivacyFlagsNode, config);

            let targetNewsPrivacyFlagsNode = $('#add-to-personalized-news-list-yes').parent().parent().get(0);
            let privacyNewsFlagsCallback = function (mutationsList, observer) {
                let alreadyTriggeredOnce = false;
                for (let index = 0; index < mutationsList.length; index++) {
                    let mutation = mutationsList[index];
                    if (mutation.type === 'attributes' &&
                        mutation.target.nodeName === 'LABEL' &&
                        mutation.attributeName === 'class' &&
                        mutation.target.classList.contains('is-invalid-input')) {
                        if (!alreadyTriggeredOnce && !alreadyTriggeredOnceForPrivacy) {
                            if ($('#loyaltyRegistration').length > 0) {
                                _self.fireGenericAnalyticsErrorEvent('loyalty_card', 'step4_personal_data', 'empty_flag_privacy');
                                if (!generalTrackingEventAlreadyTriggered) {
                                    $('body').trigger('customer:registerThird', {'status': 'error'});
                                    _self.fireSpecificAnalyticsErrorEvent('registrationLoyaltyStep4', 'loyalty_card', 'empty_flag_privacy');
                                    generalTrackingEventAlreadyTriggered = true;
                                }
                            } else if ($('#socialRegistration').length > 0) {
                                _self.fireGenericAnalyticsErrorEvent('social_registration', 'step3_personal_data', 'empty_flag_privacy');
                                if (!generalTrackingEventAlreadyTriggered) {
                                    $('body').trigger('customer:registerSocialThird', {'status': 'error'});
                                    _self.fireSpecificAnalyticsErrorEvent('registerSocialThird', 'social_registration', 'empty_flag_privacy');
                                    generalTrackingEventAlreadyTriggered = true;
                                }
                            } else {
                                if (!generalTrackingEventAlreadyTriggered) {
                                    _self.fireSpecificAnalyticsErrorEvent('registerThirdError', 'registration', 'empty_flag_privacy');
                                    generalTrackingEventAlreadyTriggered = true;
                                }
                            }

                            alreadyTriggeredOnce = true;
                            alreadyTriggeredOnceForPrivacy = true;
                        }
                    }
                }
                privacyNewsFlagsObserver.disconnect();
            };
            let privacyNewsFlagsObserver = new MutationObserver(privacyNewsFlagsCallback);
            privacyNewsFlagsObserver.observe(targetNewsPrivacyFlagsNode, config);

            let targetGenderFlagsNode = $('#gender-1').parent().parent().get(0);
            let genderFlagsCallback = function (mutationsList, observer) {
                let alreadyTriggeredOnce = false;
                for (let index = 0; index < mutationsList.length; index++) {
                    let mutation = mutationsList[index];
                    if (mutation.type === 'attributes' &&
                        mutation.target.nodeName === 'LABEL' &&
                        mutation.attributeName === 'class' &&
                        mutation.target.classList.contains('is-invalid-input')) {
                        if (!alreadyTriggeredOnce) {
                            if ($('#loyaltyRegistration').length > 0) {
                                _self.fireGenericAnalyticsErrorEvent('loyalty_card', 'step4_personal_data', 'empty_flag_gender');
                                if (!generalTrackingEventAlreadyTriggered) {
                                    _self.fireSpecificAnalyticsErrorEvent('registrationLoyaltyStep4', 'loyalty_card', 'empty_flag_gender');
                                    generalTrackingEventAlreadyTriggered = true;
                                }
                            } else if ($('#socialRegistration').length > 0) {
                                _self.fireGenericAnalyticsErrorEvent('social_registration', 'step3_personal_data', 'empty_flag_gender');
                                if (!generalTrackingEventAlreadyTriggered) {
                                    _self.fireSpecificAnalyticsErrorEvent('registerSocialThird', 'social_registration', 'empty_flag_gender');
                                    generalTrackingEventAlreadyTriggered = true;
                                }
                            } else {
                                if (!generalTrackingEventAlreadyTriggered) {
                                    $('body').trigger('customer:registerThird', {'status': 'error'});
                                    generalTrackingEventAlreadyTriggered = true;
                                }
                                _self.fireGenericAnalyticsErrorEvent('registration', 'step3_personal_data', 'empty_flag_gender');
                            }

                            alreadyTriggeredOnce = true;
                        }
                    }
                }
                genderFlagsObserver.disconnect();
            };
            let genderFlagsObserver = new MutationObserver(genderFlagsCallback);
            genderFlagsObserver.observe(targetGenderFlagsNode, config);

            let targetLoyaltyFlagsNode = $('.loyalty-flag').parent().parent().get(0);
            let loyaltyFlagsCallback = function (mutationsList, observer) {
                let alreadyTriggeredOnce = false;
                for (let index = 0; index < mutationsList.length; index++) {
                    let mutation = mutationsList[index];
                    if (mutation.type === 'attributes' &&
                        mutation.target.nodeName === 'LABEL' &&
                        mutation.attributeName === 'class' &&
                        mutation.target.classList.contains('is-invalid-input')) {
                        if (!alreadyTriggeredOnce) {
                            if ($('#loyaltyRegistration').length > 0) {
                                _self.fireGenericAnalyticsErrorEvent('loyalty_card', 'step4_personal_data', 'empty_loyalty_flag');
                                if (!generalTrackingEventAlreadyTriggered) {
                                    _self.fireSpecificAnalyticsErrorEvent('registrationLoyaltyStep4', 'loyalty_card', 'empty_loyalty_flag');
                                    generalTrackingEventAlreadyTriggered = true;
                                }
                            } else if ($('#socialRegistration').length > 0) {
                                _self.fireGenericAnalyticsErrorEvent('social_registration', 'step3_personal_data', 'empty_loyalty_flag');
                                if (!generalTrackingEventAlreadyTriggered) {
                                    _self.fireSpecificAnalyticsErrorEvent('registerSocialThird', 'social_registration', 'empty_loyalty_flag');
                                    generalTrackingEventAlreadyTriggered = true;
                                }
                            } else {
                                if (!generalTrackingEventAlreadyTriggered) {
                                    $('body').trigger('customer:registerThird', {
                                        'analyticsMode': 'only_registration',
                                        'data': {
                                            'error': ['empty_loyalty_flag']
                                        }
                                    });
                                    generalTrackingEventAlreadyTriggered = true;
                                }
                                _self.fireGenericAnalyticsErrorEvent('registration', 'step3_personal_data', 'empty_loyalty_flag');
                            }
                            alreadyTriggeredOnce = true;
                        }
                    }
                }
                loyaltyFlagsObserver.disconnect();
            };
            let loyaltyFlagsObserver = new MutationObserver(loyaltyFlagsCallback);
            if (targetLoyaltyFlagsNode) {
                loyaltyFlagsObserver.observe(targetLoyaltyFlagsNode, config);
            }
        }

        if (document.querySelectorAll('form.registrationStart').length > 0) {
            let registrationStartFrom = document.querySelectorAll('form.registrationStart')[0];
            let submitButtonAnalytics = registrationStartFrom.querySelectorAll('button[type=submit]')[0];
            submitButtonAnalytics.addEventListener('click', function (e) {
                enableRegistrationStartAnalyticsObserver();
            });
        }

        if ((window.location.pathname.includes('phone') && window.location.pathname.includes('register')) ||
            document.getElementById('registration-form-phone')) {
            let allForms = document.getElementsByTagName('FORM');
            for (let localIndex = 0; localIndex < allForms.length; localIndex++) {
                if (allForms[localIndex].classList.contains('registration')) {
                    try {
                        let registrationFormAnalytics = allForms[localIndex];
                        let submitButtonAnalytics = registrationFormAnalytics.querySelectorAll('button[type=submit]')[0];
                        submitButtonAnalytics.addEventListener('click', function (e) {
                            enablePhoneRegistrationAnalyticsObserver();
                        });
                    } catch (e) {}
                }
            }
        }

        if (document.getElementsByClassName('button-register-final')[0]) {
            document.getElementsByClassName('button-register-final')[0].addEventListener('click', function (e) {
                enableFinalRegistrationAnalyticsObservers();
            });
        }

        $('#registration-form-phone, #registration-form-prefix').on('change', (e) => {
            if ($('.registration-phone-confirm-block').hasClass('2OptFlow')
                && !$('.registration-phone-confirm-block').hasClass('hide')) {
                $('.registerPhoneButton').prop('disabled', false);
                $('#registration-form-phone-confirm').attr('required', false);
                $('.registration-phone-confirm-block').addClass('hide');
                $('#registration-form-phone-confirm').val('');
                $('.login-form-error').html('').removeClass('login-form-error-block');
                $('#reg-phone-error').removeClass('hide');
            }
        });
    }

    forgotPassword (modalToClose = false) {
        const self = this;
        $('#password-reset, .password-reset').on('click', function (e) {
            e.preventDefault();
            if (modalToClose) {
                modalToClose.close();
                modalToClose.destroy();
            }
            const htmlContent = $($(this).data('target')).clone().html();
            // create and open confirmation modal
            const modal = newModalFromString(htmlContent, false, ['layer-password-modal']);
            modal.open();
            self.resetPasswordForm();
            $(modal.modalBox).find('.request-password-title').removeClass('hidden');
            $(modal.modalBox).find('.social-request-password-title').addClass('hidden');
            $(modal.modalBox).find('.ico-center-send-mail').addClass('hidden');
            $(modal.modalBox).find('.request-password-body-description').removeClass('hidden');
            $(modal.modalBox).find('.social-request-password-body-description').addClass('hidden');
            $(modal.modalBox).on('click', '.close, .btn-close', (e) => {
                e.preventDefault();
                modal.close();
                modal.destroy();
            });
        });
    };

    resetPasswordForm () {
        $('.reset-password-form').submit(function (e) {
            var form = $(this);
            e.preventDefault();
            FormHelpers.clearPreviousErrors(form);
            var url = form.attr('action');
            $.spinner().start();
            $('.reset-password-form').trigger('login:register', e);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    form.spinner().stop();
                    var emailField = $('#reset-password-email');
                    var errorContainer = $('#reset-password-email-error');
                    if (!data.success) {
                        if (data.fields) {
                            FormHelpers.loadFormErrors(form, data.fields);

                            emailField.removeAttr('aria-invalid');
                            errorContainer.addClass('invisible');

                            if (data.fields.loginEmail) {
                                errorContainer.removeClass('invisible');
                                emailField.attr('aria-invalid', 'true');
                            }
                        }
                    } else {
                        $('.invalid-feedback').attr('aria-invalid', 'false');
                        $('.request-password-title', form).text(data.receivedMsgHeading);
                        $('.social-request-password-title').text(data.receivedMsgHeading);
                        $('.request-password-body', form).empty()
                            .append('<p>' + data.receivedMsgBody + '</p>');
                        $('.ico-center-send-mail').removeClass('hidden');
                        $('.social-request-password-body-description').addClass('hidden');
                        $('.layer-password-modal').addClass('step-2');
                        if (!data.mobile) {
                            $('#submitEmailButton', form)
                                .text(data.buttonText)
                                .attr('data-dismiss', 'modal')
                                .addClass('btn-close button-secondary');
                        } else {
                            $('.send-email-btn', form).empty()
                                .html('<a href="' +
                                    data.returnUrl +
                                    '" class="button">' +
                                    data.buttonText + '</a>'
                                );
                        }
                    }
                },
                error: function () {
                    form.spinner().stop();
                }
            });
            return false;
        });
    };

    checkoutLogin () {
        $('form.login').submit(function (e) {
            var form = $(this);
            e.preventDefault();
            var url = form.attr('action');
            $.spinner().start();
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    form.spinner().stop();
                    if (!data.success) {
                        FormHelpers.init(form, data);
                    } else {
                        location.href = data.redirectUrl;
                    }
                },
                error: function (err) {
                    form.spinner().stop();
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    }
                }
            });
            return false;
        });
    };

    checkoutRegisterForm () {
        $('form.checkout-registration').submit(e => {
            e.preventDefault();
            var form = $(e.currentTarget);
            var url = form.attr('action');
            $.spinner().start();
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: data => {
                    form.spinner().stop();
                    if (!data.success) {
                        FormHelpers.init(form, data);
                    } else {
                        location.href = data.redirectUrl;
                    }
                },
                error: err => {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    }
                    form.spinner().stop();
                }
            });
            return false;
        });
    };

    policyPrivacyFlag () {
        var form = document.querySelector('form.registration');
        if (!form) {
            return;
        }
        form.addEventListener('change', function () {
            $('.activable-after-change').prop('disabled', false);
        });
        $('.add-to-email').on('change', (e) => {
            const $container = $(e.target).closest('.accordion-item, .cc-accountPage-prefrencesSection');
            const $profilingRadios = $container.find('.add-to-personalized-list');
            const $noProfilingInput = $profilingRadios.filter('[value="false"]');
            const initialProfilingAgreement = $noProfilingInput.data('initial-profiling-agreement');

            if (e.target.value === 'true' && e.target.checked) {
                const canEnableProfiling = initialProfilingAgreement === undefined || initialProfilingAgreement === true;
                $profilingRadios.prop('disabled', !canEnableProfiling);
            } else {
                $profilingRadios.prop('disabled', true);
                $noProfilingInput.prop('checked', true);
            }
        });

        function newsletterPrefAnalyticsRegister (e) {
            initNewsletterAnalyticsBrands();
            let brandName = $(e.currentTarget).attr('name').split('-')[1];
            if (window.newsletterPreferenceBrands.indexOf(brandName) === -1) {
                window.newsletterPreferenceBrands.push(brandName);
            }
        }

        $('.add-to-email').on('change', newsletterPrefAnalyticsRegister);
        $('.add-to-personalized-list').on('change', newsletterPrefAnalyticsRegister);

        $('body').on('click', '.save-button-newsletter-pref', function (e) {
            let newsletterFormData = $('form.newsletter-preference-form').serialize();
            let direktMarketingAgreement = newsletterFormData.indexOf('directMarketingAgreement-INTIMISSIMI=true') > -1;
            let profilingAgreement = newsletterFormData.indexOf('profilingAgreement-INTIMISSIMI=true') > -1;
            $('body').trigger('customer:newsletterPreferencesSave', {
                'direktMarketingAgreement': direktMarketingAgreement,
                'profilingAgreement': profilingAgreement,
                'brands': window.newsletterPreferenceBrands,
            });
        });
    };

    editProfileForm () {
        var form2 = document.querySelector('form.edit-profile-form');
        if (form2) {
            form2.addEventListener('change', function () {
                $('.activable-after-change-1').prop('disabled', false);
            });
        }
        let formatPattern = $('.datepickerTriggerElement').data('date-format-pattern');

        $('.datepickerTriggerElement').fdatepicker({
            format: formatPattern,
            disableDblClickSelection: true,
            leftArrow: '<<',
            rightArrow: '>>',
            closeIcon: 'X',
            closeButton: false
        }).on('changeDate', function (ev) {
            // Reset error message on date selection
            $('.myaccount-date-picker .login-form-error').text('');

            let date = new Date(ev.date.valueOf() + ev.date.getTimezoneOffset() * 60000);
            var datestring = formatDate(date, formatPattern);
            $('#dpReg').val(datestring);
            $('.datepickerTriggerElement').data('date', datestring);
            if ($('.activable-after-change-1')) {
                $('.activable-after-change-1').prop('disabled', false);
            }
        });

        if ($('#dpReg').val() !== '') {
            let formattedDate = $('#dpReg').val();
            $('.datepickerTriggerElement').data('date', formattedDate);
        }

        const checkPreferencesEnabled = () => {
            if ($('#promotions-1')[0]) {
                if ($('#promotions-1')[0].checked) {
                    $('[name="profiling"]').prop('disabled', false);
                } else {
                    $('[name="profiling"]').prop('checked', false);
                    $('#profiling-2').prop('checked', true);
                    $('[name="profiling"]').prop('disabled', true);
                }
            }
        };

        checkPreferencesEnabled();
        $('[name="promotions"]').on('change', checkPreferencesEnabled);

        $('form.edit-profile-form').submit(function (e) {
            var $form = $(this);
            e.preventDefault();
            var url = $form.attr('action');
            $.spinner().start();
            $('form.edit-profile-form').trigger('profile:edit', e);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: $form.serialize(),
                success: function (e) {
                    $form.spinner().stop();
                    if (!e.success) {
                        FormHelpers.init($form, e);
                        // if ($('.phone-error')) {
                        //     $('.phone-error').html(e.phoneError);
                        // }
                        //  $('#login-form-error-edit').addClass('login-form-error-block');
                    } else {
                        // $('#login-form-error-edit').removeClass('login-form-error-block');
                        location.href = e.redirectUrl;
                    }
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    }
                    $form.spinner().stop();
                }
            });
            return false;
        });
    };

    editPasswordForm () {
        var newPasswordInput = document.getElementById('newPassword');
        var newPasswordConfirmInput = document.getElementById('newPasswordConfirm');

        // if both password input fields are present and aren't empty, enable the save button
        if (newPasswordInput && newPasswordConfirmInput) {
            newPasswordInput.addEventListener('focus', function () {
                $('.js-password-checklist').removeClass('hidden');
            });

            newPasswordInput.addEventListener('input', function () {
                var isPasswordFilled = newPasswordInput.value.length > 0;
                var isPasswordConfirmedFilled = newPasswordConfirmInput.value.length > 0;
            
                $('.activable-after-change-2').prop('disabled', !(isPasswordFilled && isPasswordConfirmedFilled));

                var val = newPasswordInput.value || '';
                var hasLength = val.length >= 8;
                var hasUppercase = /[A-Z]/.test(val);
                var hasLowercase = /[a-z]/.test(val);
                var hasNumber = /[0-9]/.test(val);
                var hasSpecial = /[^A-Za-z0-9]/.test(val);

                $('.js-password-rule-length').toggleClass('is-complete', hasLength);
                $('.js-password-rule-uppercase').toggleClass('is-complete', hasUppercase);
                $('.js-password-rule-lowercase').toggleClass('is-complete', hasLowercase);
                $('.js-password-rule-number').toggleClass('is-complete', hasNumber);
                $('.js-password-rule-special').toggleClass('is-complete', hasSpecial);
            });
            
            newPasswordConfirmInput.addEventListener('input', function () {
                var isPasswordFilled = newPasswordInput.value.length > 0;
                var isPasswordConfirmedFilled = newPasswordConfirmInput.value.length > 0;
            
                $('.activable-after-change-2').prop('disabled', !(isPasswordFilled && isPasswordConfirmedFilled));
            });
        }
        $('form.change-password-form').submit(function (e) {
            e.preventDefault();
            var form = $(this);
            FormHelpers.clearPreviousErrors(form);
            var url = form.attr('action');
            $.spinner().start();
            $('form.change-password-form').trigger('password:edit', e);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    form.spinner().stop();
                    if (!data.success) {
                        if (data.fields) {
                            FormHelpers.loadFormErrors(form, data.fields);
                        }
                    } else {
                        location.href = data.redirectUrl;
                    }
                },
                error: function (data) {
                    // if (data.responseJSON.redirectUrl) {
                    //     window.location.href = data.responseJSON.redirectUrl;
                    // }
                    form.spinner().stop();
                }
            });
            return false;
        });
    };

    editEmailForm () {
        var changeEmailForm = document.querySelector('form.change-email-form');
        if (changeEmailForm) {
            changeEmailForm.addEventListener('input', function () {
                if ($('#registration-form-email').val() === $('form.change-email-form').data('initial-value')) {
                    $('.activable-after-change-email').prop('disabled', true);
                } else {
                    $('.activable-after-change-email').prop('disabled', false);
                }
            });
        }
        var $form3 = $('form.change-email-form');
        $('.activable-after-change-email').on('click', function (e) {
            e.preventDefault();
            $.spinner().start();
            $('.js-change-email-error-msg').addClass('hidden');
            if (!$form3.parsley().validate()) {
                $.spinner().stop();
                return;
            }

            // PreSaveNewEmail
            var url = $form3.data('pre-action-url');
            if (!url) {
                $.spinner().stop();
                return;
            }

            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: $form3.serialize(),
                success: function (data) {
                    $.spinner().stop();
                    if (!data.success) {
                        var errorChangeEmail = '';
                        if (data.herokuError) {
                            errorChangeEmail = data.errorMessage;
                        } else if (data.sfccError) {
                            errorChangeEmail = data.errorMessage;
                        // Russia
                        } else if (data.validDomainError) {
                            errorChangeEmail = data.errorMessage;
                        }
                        $('.js-change-email-error-msg').text(errorChangeEmail);
                        $('.js-change-email-error-msg').removeClass('hidden');
                        $('#registration-form-email').removeClass('is-valid-input');
                        $('#registration-form-email').addClass('is-invalid-input');
                    } else {
                        // Systems to update
                        $('.js-system-to-update').html(data.modalContent);

                        const htmlContent = $('#editEmailAddressModal').html();

                        const onChangeEmailPopupClose = () => {
                            // Redirect to the account page with info banner
                            if (!$('.js-confirmation-message-two').hasClass('hidden')) {
                                if ($('.js-confirmation-message-two').data('url-redirect')) {
                                    window.location.href = $('.js-confirmation-message-two').data('url-redirect');
                                }
                            }
                        };

                        // create and open confirmation modal
                        const modal = newModalFromString(htmlContent, false, [], null, onChangeEmailPopupClose);
                        modal.open();
                        $(modal.modalBox)
                            .find('.close')
                            .on('click', function (e) {
                                e.preventDefault();
                                modal.close();
                            });

                        $('[data-dismiss="modal"]').on('click', function (e) {
                            e.preventDefault();
                            modal.close();
                        });

                        $('.edit-email-confirmation-btn').click(function (f) {
                            $.spinner().start();
                            if (!$form3.parsley().validate()) {
                                $.spinner().stop();
                                return;
                            }
                            $.ajax({
                                url: $form3.attr('action'),
                                type: 'post',
                                dataType: 'json',
                                data: $form3.serialize(),
                                success: function (data) {
                                    if (data.success) {
                                        $('.js-confirmation-message-one').addClass('hidden');
                                        $('.js-confirmation-message-two').removeClass('hidden');
                                        $('.js-confirmation-message-two').data('url-redirect', data.redirectUrl);
                                    }
                                    // TODO: Redirect with error message to the Account-Profile
                                    $.spinner().stop();
                                },
                                error: function (err) {
                                    // modal.close();
                                    if (err.responseJSON && err.responseJSON.redirectUrl) {
                                        window.location.href = err.responseJSON.redirectUrl;
                                    }
                                    $.spinner().stop();
                                }
                            });
                        });
                    }
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
        $('form.change-email-form').submit(function (e) {
            e.preventDefault();
            var form = $(this);
            FormHelpers.clearPreviousErrors(form);
            var url = form.attr('action');
            $.spinner().start();
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    form.spinner().stop();
                    if (!data.success) {
                        if (data.fields) {
                            FormHelpers.loadFormErrors(form, data.fields);
                        }
                    } else {
                        location.href = data.redirectUrl;
                    }
                },
                error: function (data) {
                    form.spinner().stop();
                }
            });
            return false;
        });

        $('form.confirm-change-email-form').submit(function (e) {
            e.preventDefault();
            $('.change-mail-form-error').empty().addClass('hidden');
            var form = $(this);
            FormHelpers.clearPreviousErrors(form);
            var url = form.attr('action');
            $.spinner().start();
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    form.spinner().stop();
                    if (!data.success) {
                        if (data.errorMessage) {
                            $('.change-mail-form-error').html(data.errorMessage).removeClass('hidden');
                        }
                    } else {
                        location.href = data.redirectUrl;
                    }
                },
                error: function (data) {
                    form.spinner().stop();
                }
            });
            return false;
        });

        $('body').on('keydown', '.change-email-input-text', function (e) {
            if (e.keyCode == 13) {
                e.preventDefault();
                if ($('.activable-after-change-email').attr('disabled') || $('.activable-after-change-email').prop('disabled')) {
                    return false;
                } else {
                    $('.activable-after-change-email').click();
                }
            }
        });
    };

    /**
     * Handle loyalty registration flow on MyAccount
     */
    handleMyAccountFlow () {
        var $myAccountCard = $('.my-int-no-loyalty-card-myaccount');

        if ($myAccountCard.length) {
            var myAccountLoyalty = $myAccountCard.find('.loyalty-flag-m').is(':checked');
            var myAccountBirthDate = $myAccountCard.find('#dpReg').val() !== '';
            var myAccountDateFormatPattern = $myAccountCard.find('.login-datepicker').data('date-format-pattern') || '';

            myAccountBirthDate = myAccountBirthDate && $myAccountCard.find('#dpReg').val().length >= myAccountDateFormatPattern.length;

            $myAccountCard.find('.disabledForm').prop('disabled', true);
            $myAccountCard.find('.block-associate-card').hide();
            $myAccountCard.find('.my-int-no-loyalty-card-section, .my-int-no-loyalty-bithdate-section').addClass('hidden');
            $myAccountCard.find('.cc-account__loyalty__opposition, .cc-account__loyalty__actions').addClass('hidden');

            if (myAccountLoyalty) {
                $myAccountCard.find('.my-int-no-loyalty-bithdate-section, .cc-account__loyalty__opposition, .cc-account__loyalty__actions').removeClass('hidden');

                if (myAccountBirthDate) {
                    $myAccountCard.find('.disabledForm').prop('disabled', false);
                }
            }

            return;
        }
        // Input values
        var loyalty = $('.loyalty-flag-m').is(':checked');
        var loyaltyPhysicalCard = $('.associate-loyalty-flag-m:checked').val() !== undefined && $('.associate-loyalty-flag-m:checked').val() === 'true';
        var cardValues = $('#loyalty-form-cardCode').val() !== '' && $('#loyalty-form-cardPin').val() !== '';
        var birthDate = $('#dpReg').val() !== '';
        var physicalCardLoyaltyForCurrentCountry = $('.registration-loyalty').data('physical-card');

        // Check on input values length
        cardValues = cardValues && $('#loyalty-form-cardCode').val().length >= $('#loyalty-form-cardCode').attr('minlength');
        cardValues = cardValues && $('#loyalty-form-cardPin').val().length >= $('#loyalty-form-cardPin').attr('minlength');
        birthDate = birthDate && $('#dpReg').val().length >= $('.login-datepicker').data('date-format-pattern').length;

        // Set default values to containers
        $('.disabledForm').prop('disabled', true);
        $('.block-associate-card').hide();
        $('.my-int-no-loyalty-card-section, .my-int-no-loyalty-bithdate-section').addClass('hidden');
        $('.cc-account__loyalty__opposition, .cc-account__loyalty__actions').addClass('hidden');

        // Step 1. Toggles slider
        if (loyalty) {
            $('.my-int-no-loyalty-card-section').removeClass('hidden');

            if (!physicalCardLoyaltyForCurrentCountry && $('.associate-loyalty-flag-m:checked').val() === undefined) {
                $('#associate-loyalty-no').prop('checked', true);
            }

            // Step 2a. User has physical card. Show info
            if (loyaltyPhysicalCard) {
                $('.block-associate-card').show();
            }

            // Step 2b / Step 3. User has selected either options of loyalty card
            if ($('.associate-loyalty-flag-m').is(':checked')) {
                $('.my-int-no-loyalty-bithdate-section').removeClass('hidden');
            }

            // Step 4. If birth date has been filled. Enables opposition's checkbox and CTA submit
            if (birthDate) {
                if (loyaltyPhysicalCard && cardValues && $('.associate-loyalty-flag-m:checked').val() !== undefined) {
                    $('.disabledForm').prop('disabled', false);
                } else if (!loyaltyPhysicalCard && $('.associate-loyalty-flag-m:checked').val() !== undefined) {
                    $('.disabledForm').prop('disabled', false);
                }
            }
        }
    };

    resendActivationEmail () {
        $('body').on('click', '.resend-activation-email', function (e) {
            e.preventDefault();
            var url = $(e.currentTarget).attr('href');
            var email = $(e.currentTarget).data('email');
            const payload = {
                email: email
            };
            $.spinner().start();
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: payload,
                success: function (data) {
                    $.spinner().stop();
                    if (data.success) {
                        location.href = data.redirectUrl;
                    }
                },
                error: function (data) {
                    $.spinner().stop();
                }
            });
        });
    };

    socialLoginHandler (fromLayer = false) {
        const _self = this;

        var processSocialLogin = function (e, data) {
            var loginResult = data && data.loginResult;
            // gigyaHandlerResult dispatches the same result both as native and as jQuery event:
            // process it only once (double AJAX call and double analytics events otherwise)
            if (!loginResult || loginResult === _self.lastSocialLoginResult) {
                return;
            }
            _self.lastSocialLoginResult = loginResult;

            var containerID = data.loginResult && data.loginResult.containerID;
            var url = containerID ? $('#' + containerID).data('url') : null;
            if (!url) {
                url = $('.socialLoginContainer').data('url');
                if ($('#loginGigya').length) {
                    url = $('#loginGigya.socialLoginContainer').data('url');
                }
            }
            $.spinner().start();
            //$('form.registration').trigger('login:register', e);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: data.loginResult.user,
                success: function (data) {
                    $.spinner().stop();
                    if (containerID && $('#' + containerID).closest('#unified-login-form').length) {
                        data.regFlowPosition = $('.js-unified-page-wrapper').length ? 'landing_page' : 'modal';
                    }
                    if (!data.success) {
                        if (data.sfccRegisteredUser) {
                            // switch tab to "accedi"
                            if ($('.js-link-access').length) {
                                $('.js-link-access').click();
                            }
                            $('.social-login-form-error').empty().html(data.error);
                            $('.social-login-form-error').removeClass('hidden');

                            $('body').trigger('customer:socialRegistration', data);
                            _self.fireGenericAnalyticsErrorEvent('social_registration', 'step1_email', 'email_or_number_already_registered');
                            $('body').trigger('customer:social_email_already_used', {
                                'type': 'email',
                                'socialName': data.socialName,
                                'errorMsg': 'email_already_registered'
                            });
                        } else if (data.errorMessage) {
                            if ($('.js-link-access').length) {
                                $('.js-link-access').click();
                            }
                            $('.social-login-form-error').empty().html(data.error);
                            $('.social-login-form-error').removeClass('hidden');
                            if (data.socialLogin) {
                                $('body').trigger('customer:socialLogin', data);
                                _self.fireGenericAnalyticsErrorEvent('social_login', 'step1_login', 'generic_error');
                            }
                        }
                    } else {
                        $('body').trigger('customer:socialRegistration', data);
                        localStorage.setItem('socialFirstStepMail', '');
                        if (data.socialLogin) {
                            $('body').trigger('customer:socialLogin', data);
                        }

                        var isUserLoyalty = data.response && data.response.customerFidelitySubscriptions && RegistrationHelper.isUserLoyaltyForThisBrand(data.response.customerFidelitySubscriptions);
                        if (data.socialLogin && !isUserLoyalty && RegistrationHelper.isLoyaltyAvailable()) {
                            $('.js-unified-modal-loyalty-registration').val('user-is-logged');
                            $('.js-unified-modal-loyalty-registration').trigger('click');
                            return;
                        } else if (RegistrationHelper.isNewRegistrationActive() && data.socialLogin && !isUserLoyalty && RegistrationHelper.isLoyaltyAvailable()) {
                            $('.js-modal-loyalty-registration-fake').val('user-is-logged');
                            $('.js-modal-loyalty-registration-fake').trigger('click');
                            return;
                        }

                        if (!data.socialLogin) {
                            $('body').trigger('unifiedRegistration:socialRegistration', data);
                            return;
                        }

                        if (fromLayer && data.socialLogin && data.rurl !== '6') {
                            location.reload();
                        } else {
                            location.href = data.redirectUrl;
                        }
                    }
                },
                error: function (data) {
                    $.spinner().stop();
                }
            });
        };

        $('body').off('socialLogin:handler.customer').on('socialLogin:handler.customer', processSocialLogin);

        if (_self.socialLoginNativeListener) {
            window.removeEventListener('socialLogin:nativeHandler', _self.socialLoginNativeListener);
        }
        _self.socialLoginNativeListener = function (event) {
            processSocialLogin(event, event.detail);
        };
        window.addEventListener('socialLogin:nativeHandler', _self.socialLoginNativeListener);
    }

    ratingAndReviewsTabsHandler () {
        $('body').on('click', '.product-review-container .product-review-category-item', function (e) {
            $('body').trigger('customer:ratingAndReviewsTabsAction', $(e.currentTarget).data('analytics-name'));
        });
    }
}

const customer = new Customer();
export default customer;
